import { render } from "./OverviewPage.vue?vue&type=template&id=f50a992a"
const script = {}

import "./OverviewPage.vue?vue&type=style&index=0&id=f50a992a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__